import { useQuery } from "@tanstack/react-query";
import {
  getWorkspaces,
  getWorkspacesCostTotal,
  getWorkspacesCostBreakdown,
  getWorkspacesCostTrendsByProduct,
  getWorkspacesEfficiency,
} from "@/helpers/apis";
import type {
  WorkspacesCostParams,
  WorkspacesTrendsParams,
  WorkspacesBreakdownParams,
} from "../types";

export const useWorkspaces = (enabled = true) => {
  return useQuery({
    queryKey: ["workspaces"],
    queryFn: () => getWorkspaces(),
    enabled,
  });
};

export const useWorkspacesCostTotal = (params: WorkspacesCostParams, enabled = true) => {
  return useQuery({
    queryKey: ["workspaces-cost-total", params.start_date, params.end_date, params.workspace_id],
    queryFn: () => getWorkspacesCostTotal(params),
    enabled,
  });
};

export const useWorkspacesCostBreakdown = (params: WorkspacesBreakdownParams, enabled = true) => {
  return useQuery({
    queryKey: [
      "workspaces-cost-breakdown",
      params.start_date,
      params.end_date,
      params.group_by,
      params.workspace_id,
    ],
    queryFn: () => getWorkspacesCostBreakdown(params),
    enabled,
  });
};

export const useWorkspacesCostTrendsByProduct = (
  params: WorkspacesTrendsParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [
      "workspaces-cost-trends-by-product",
      params.start_date,
      params.end_date,
      params.granularity,
      params.workspace_id,
    ],
    queryFn: () => getWorkspacesCostTrendsByProduct(params),
    enabled,
  });
};

export const useWorkspacesEfficiency = (params: WorkspacesCostParams, enabled = true) => {
  return useQuery({
    queryKey: ["workspaces-efficiency", params.start_date, params.end_date, params.workspace_id],
    queryFn: () => getWorkspacesEfficiency(params),
    enabled,
  });
};
